/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePerson/view.blocks to change it.
import Choice from 'DesignSystem/Choice/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePerson({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePerson",
  focusArea,
  responsiblePersonQuestion,
  onClick,
  value,
  patientName
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="ResponsiblePerson.Vertical"
  data-view-path={viewPath}
 ref={focusArea}
 style={{'--o-1-ZRsU1L': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResponsiblePerson.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text={responsiblePersonQuestion}
/>
</div>
<Choice
  viewPath={`${viewPath}/Choice`}
 id="patient"
 textTransform="capitalize"
 onClick={onClick}
 selected={value}
 text={patientName}
/>
<Choice
  viewPath={`${viewPath}/Choice`}
 id="other-person"
 onClick={onClick}
 selected={value}
 text="Other Person"
/>
</div>
{children}
</React.Fragment>)
}